<script setup lang="ts">
import { ProjectListed } from "@/apps/page/project/sidebar/sections/tool/project-listed.interface";
import AddTool from "@/apps/page/project/sidebar/sections/tool/AddTool.vue";
import { useState } from "@/store/vuex-composition-mappers";
import { computed } from "vue";
import { PAGE_SECTION_KINDS } from "@/apps/page/services/page.service";

defineProps<{ projects: ProjectListed[] }>();
const emit = defineEmits(["dragStart"]);

// @ts-expect-error (TODO: fix this)
const { page } = useState("page", ["page"]);
const styleValues = computed(() => page.value.colors || {});

function handleDragStart(event: DragEvent, project: ProjectListed) {
    event.dataTransfer?.setData(
        "new-easypage-section",
        JSON.stringify({
            type: PAGE_SECTION_KINDS.TOOL,
            data: project,
        })
    );
    if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = "copy";
    }

    emit("dragStart");
}
</script>

<template>
    <div class="p-2">
        <div
            v-for="project of projects"
            :key="project.uuid"
            class="flex items-center flex-col gap-4 ct-ring-1 hover:ct-ring-brand cursor-move transition-all duration-200"
            draggable="true"
            @dragstart="(e) => handleDragStart(e, project)"
        >
            <AddTool :project="project" :styleValues="styleValues" :fontFamily="page.fontFamily" />
        </div>
    </div>
</template>

<style scoped></style>
